<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <h1>Recreational Burn Application</h1>

    <div class="form-wrapper">
      <div class="form-navbar">
        <div class="title-nav">
          <label class="col-form-label ml-2 d-none d-sm-block">
            Open Burn Application
          </label>
          <div class="btn-group" role="group" aria-label="Save And Close Buttons">
            <button class="btn btn-link" @click="cancel">
              <font-awesome-icon icon="times" />
              Cancel
            </button>
            <button class="btn btn-link"
                    v-if="isLastPage"
                    @click="submitForm">
              <font-awesome-icon :icon="['far', 'check-circle']" />
              Submit Form
            </button>
          </div>
        </div>

        <div class="nav-links">
          <a class="btn btn-link end" @click="previousSection">
            <font-awesome-icon icon="chevron-left" />
          </a>
          <router-link v-for="(route, index) in routes"
                       :to="{name: route, query: $route.query}"
                       v-bind:key="route"
                       v-bind:class="{visited: index < currentRoute, error: $v.pages[route].$error }">
            {{index + 1}}
          </router-link>
          <a class="btn btn-link end" @click="nextSection">
            <font-awesome-icon icon="chevron-right" />
          </a>
        </div>
      </div>
      <div class="section-title">
        {{routeNames[currentRoute]}}
      </div>

      <div class="row no-gutters">
        <div class="col" style="padding: 1%;">
          <router-view :form="form"
                       :val="$v"
                       class="h-100 d-flex align-content-between flex-wrap"
                       v-bind:fetchingData.sync="fetchingData"
                       v-bind:title.sync="title">
          </router-view>
        </div>
        <div class="col-3 d-md-block d-none">
          <div class="save-panel">
            <div class="button-wrapper">
              <button class="btn btn-primary mt-2" @click="cancel">
                <font-awesome-icon icon="times" />
                Cancel
              </button>
              <div class="w-100"></div>
              <button class="btn btn-success mt-2"
                      v-if="isLastPage"
                      @click="submitForm">
                <font-awesome-icon :icon="['far', 'check-circle']" />
                Submit Form
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { OpenBurnPermitApplication } from '~/js/FormObjects';
import { OpenBurnRecPermitApplicationValidation } from '@/js/FormValidations';
import { saveOpenBurnRecApplication, getPrices, capitalize, errorNotification } from '~/js/FormFunctions';
import { CapitalizeFilter } from '@/js/Mixins';

const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

export default {
  name: 'RecreationalApplication',
  props: {
  },
  mixins: [CapitalizeFilter],
  data() {
    return {
      form: new OpenBurnPermitApplication(),
      title: null,
      currentRoute: 0,
      routes: [
        'RecApplicationInformation',
        'RecSignature',
      ],
      routeNames: [
        'Application Information',
        'Signature',
      ],
      permitPrices: [],
      fetchingData: false,
    };
  },
  mounted() {
    const self = this;
    if (this.$route.params.form != undefined) {
      this.form = this.$route.params.form;
    } else {
      this.form.permitNumber = '';
    }
    this.$router.push({ name: 'RecApplicationInformation', query: this.$route.query });
  },
  validations: {
    form: new OpenBurnRecPermitApplicationValidation(),
    pages: {
      RecApplicationInformation: ['form.address1', 'form.address2', 'form.city', 'form.burnAddress1', 'form.burnAddress2', 'form.burnCity', 'form.companyName', 'form.contactEmail', 'form.contactFirstName', 'form.contactLastName', 'form.localFireDepartment', 'form.nameOfForestPreserve'],
      RecSignature: ['form.signature', 'form.signatureDate', 'form.signatureTitle'],
    },
  },
  methods: {
    previousSection() {
      if (this.currentRoute > 0) {
        this.$router.push({ name: this.routes[this.currentRoute - 1], query: this.$route.query });
      }
    },
    nextSection() {
      if (this.currentRoute < this.routes.length) {
        this.$router.push({ name: this.routes[this.currentRoute + 1], query: this.$route.query });
      }
    },
    submitForm() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$notify('Errors during permit application validation.', 'error');
        return;
      }

      const self = this;

      const formData = new FormData();

      formData.append('form', JSON.stringify(this.form));
      this.fetchingData = true;
      return new Promise((resolve, reject) => {
        self.$http.post('/api/openburn/saverec', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            // console.log(response)
            self.fetchingData = false;
            self.form.permitNumber = response.data;
            self.$store.commit('application', self.form);
            self.$router.push({ name: 'OpenBurnRecReview' });
          })
          .catch((error) => {
            self.fetchingData = false;
            errorNotification('Error saving application record: ', error);
            reject(error);
          });
      });
    },

    cancel() {
      this.$router.push({ name: 'PermitApplicationCancel', params: { projectType: this.projectType } });
    },
  },
  watch: {
    $route(to) {
      this.currentRoute = this.routes.findIndex(route => to.name.endsWith(route));
    },
  },
  computed: {
    isLastPage() {
      return this.currentRoute === this.routes.length - 1;
    },
    canSave() {
      return true;
      // return !this.$v.form.confirmEmail.$invalid
    },
  },
};
</script>
